var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { unwrapWebsiteBuilderApiData } from "./response";
const CREATE_COMPANY_WEBSITE_ORDER = "/api/v2/company-websites/orders";
export const createCompanyWebsiteOrder = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const response = yield this.axiosInstance.post(CREATE_COMPANY_WEBSITE_ORDER, payload, config);
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error creating Company Website order:", error);
            throw error;
        }
    });
};
